import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { FormField } from '../../../components/FormFields';
import { Search } from '../../../components/Icon';
import { Input } from '../../../components/Input';
import { Pagination } from '../../../components/Pagination';
import { fetchCompanyInvoices } from '../../Invoices/actions';
import { selectWorks } from '../../Api/selectors';
import { REQUEST_INVOICE_FILTER } from '../../Invoices/constants';
import { selectCompanyInvoices, selectPaginator } from '../../Invoices/selectors';
import { InvoicesCompanyTable } from '../../Invoices/components/InvoicesCompanyTable';
import PaginationComponent from '../../../containers/App/Components/Pagination/Pagination';
import styles from './CardInvoices.module.css';

const Container = styled.div`
display: flex;
justify-content: center;
  width: 100%;
  font-size: 14px;
  background-color:white;

  .cell:first-child {
    text-transform: capitalize;
  }
  .wide {
    width: 100%;
    max-width: 800px;
    /* overflow-x: ${props => (props.itemsLength ? 'auto' : '')}; */
  }

  .info-card {
  border: none;
  }

`;

const STATE = {
  searchString: '',
};
/* eslint-disable react/prefer-stateless-function */
class CompanyInvoicesCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  selectPage = newPage => {
    if (newPage === this.state.currentPage) return;
    const newOffset = this.props.paginator.limit ? newPage * this.props.paginator?.limit : newPage * 50;
    this.setState({ currentPage: newPage }, this.props.changeFilter(newOffset));
  };

  handleKeyPress = event => {
    if (event.key === 'Enter') {
      this.props.setSearchString(this.state.searchString);
    }
  };

  doSearch() {
    this.props.setSearchString(this.state.searchString);
  }

  render() {
    return (
      <Container itemsLength={this.props.invoices?.length}>
        <Card className="vehicle-info-card info-card data wide" style={{ width: '100%' }}>
          <HBox vCenter>
            <h2>{this.lbl('company.info.data.invoices')}</h2>
          </HBox>

          <div className={styles.searchContainer}>
            <input
              className={`form-control fw-light ${styles.input}`}
              value={this.state.searchString}
              onChange={evt => this.setState({ searchString: evt.target.value })}
              onKeyPress={this.handleKeyPress}
            />
            <button
              className={`btn btn-outline-secondary ${styles.button}`}
              type="button"
              onClick={this.doSearch.bind(this)}
            >
              <Search />
            </button>
          </div>

          <div className={styles.containerTable}>
            <InvoicesCompanyTable companyDetails />
          </div>
          {this.props.paginator?.itemsCount > this.props.paginator?.limit && (
            <div className="d-flex justify-content-center mt-2">
              <PaginationComponent size="pagination-sm" paginator={this.props.paginator} selectPage={this.selectPage} />
            </div>
          )}
        </Card>
      </Container>
    );
  }
}

CompanyInvoicesCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    invoices: selectCompanyInvoices(),
    paginator: selectPaginator(),
    work: selectWorks([REQUEST_INVOICE_FILTER]),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    changeFilter: offset => {
      dispatch(fetchCompanyInvoices(ownProps.company?.id, '', offset));
    },
    setSearchString(text) {
      dispatch(fetchCompanyInvoices(ownProps.company?.id, text));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CompanyInvoicesCard = compose(withConnect, withRouter)(CompanyInvoicesCardComp);
